import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Countdown',
    defaultMessage: 'Countdown',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  heading: {
    id: 'Heading',
    defaultMessage: 'Heading',
  },
  targetDate: {
    id: 'Target date',
    defaultMessage: 'Target date',
  },
  daysLabel: {
    id: 'Days label',
    defaultMessage: 'Days label',
  },
  hoursLabel: {
    id: 'Hours label',
    defaultMessage: 'Hours label',
  },
  minutesLabel: {
    id: 'Minutes label',
    defaultMessage: 'Minutes label',
  },
  secondsLabel: {
    id: 'Seconds label',
    defaultMessage: 'Seconds label',
  },
});

/**
 * Schema do bloco Countdown. Fuso: o widget `datetime` do Plone grava
 * ISO 8601 com timezone (UTC) — ver docs/specs/schema-decisions.md §4.
 * Rótulos vazios caem em defaults i18n (Days/Hours/Minutes/Seconds) e
 * `heading` vazio cai no default i18n "Starts in" — ver CountdownView.
 */
const CountdownSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: [
        'heading',
        'targetDate',
        'daysLabel',
        'hoursLabel',
        'minutesLabel',
        'secondsLabel',
      ],
    },
  ],
  properties: {
    heading: {
      title: intl.formatMessage(messages.heading),
      type: 'string',
    },
    targetDate: {
      title: intl.formatMessage(messages.targetDate),
      widget: 'datetime',
    },
    daysLabel: {
      title: intl.formatMessage(messages.daysLabel),
      type: 'string',
    },
    hoursLabel: {
      title: intl.formatMessage(messages.hoursLabel),
      type: 'string',
    },
    minutesLabel: {
      title: intl.formatMessage(messages.minutesLabel),
      type: 'string',
    },
    secondsLabel: {
      title: intl.formatMessage(messages.secondsLabel),
      type: 'string',
    },
  },
  required: [],
});

export default CountdownSchema;
